import React from 'react'
import {SERIES_COLORS} from '../../constants'

const Legend = ({labels, colors, target = null}) => (
    <div className="legend">
        {labels.map((label, index) => (
            <span key={label}>
                <span className="dot" style={{background: `var(${(colors && colors[index]) || SERIES_COLORS[index % SERIES_COLORS.length]})`}}/>
                {label}
            </span>
        ))}
        <span><span className="dash"/>Total</span>
        {target > 0 && <span><span className="dash lim"/>Ngưỡng {+(target * 100).toFixed(2)}%</span>}
    </div>
)

export default Legend
